import type { ICancellationPositionPayment, ICancellationView } from "@/data/model/Cancellation";
import { PaymentProvider, PaymentState } from "@/data/model/Enums";
import type { IPaymentMethodSplit } from "@/data/model/Order";
import { Format } from "@/data/util/Format";

import type { PaymentMethodCell } from "@/operator/controller/PaymentsController";

export class PaymentMethodUtil {
    public static generatePaymentMethodSplitDivs(unknownText: string, transactions: IPaymentMethodSplit[]): string[] {
        const container = new Array<string>();
        let voucherIconAppended = false;

        for (const transaction of transactions) {
            if (transaction.code === "Voucher") {
                if (voucherIconAppended) {
                    continue;
                } else {
                    voucherIconAppended = true;
                }
            }

            container.push(
                this.generatePaymentMethodDivIconFinal(
                    unknownText,
                    transaction.brand,
                    transaction.ccDigits,
                    transaction.region,
                    transaction.actualPaymentMethodImagePath,
                    transaction.predefinedPaymentMethodImagePath,
                    transaction.customPaymentMethodImagePath,
                    transaction.provider,
                    undefined
                )
            );
        }

        return container;
    }

    public static generatePaymentMethodDivIconFromCancellationView(
        unknownText: string,
        transaction: ICancellationView
    ): string {
        return this.generatePaymentMethodDivIconFinal(
            unknownText,
            transaction.brand,
            transaction.ccDigits,
            transaction.region,
            transaction.actualPaymentMethodImagePath,
            transaction.predefinedPaymentMethodImagePath,
            transaction.customPaymentMethodImagePath,
            transaction.provider,
            undefined
        );
    }

    public static generatePaymentMethodDivIconFromCancellationPositionPayment(
        unknownText: string,
        transaction: ICancellationPositionPayment
    ): string {
        return this.generatePaymentMethodDivIconFinal(
            unknownText,
            transaction.brand,
            transaction.ccDigits,
            transaction.region,
            transaction.actualPaymentMethodImagePath,
            transaction.predefinedPaymentMethodImagePath,
            transaction.customPaymentMethodImagePath,
            transaction.provider,
            undefined
        );
    }

    public static generatePaymentMethodDivIconFromPaymentMethodCell(
        unknownText: string,
        transaction: PaymentMethodCell
    ): string {
        return this.generatePaymentMethodDivIconFinal(
            unknownText,
            transaction.brand,
            transaction.ccDigits,
            transaction.region,
            transaction.actualPaymentMethodImagePath,
            transaction.predefinedPaymentMethodImagePath,
            transaction.customPaymentMethodImagePath,
            transaction.provider,
            transaction.state
        );
    }

    public static generatePaymentMethodDivIconFinal(
        unknownText: string,
        brand: string | undefined,
        ccDigits: string | undefined,
        region: string | undefined,
        actualPaymentMethodImagePath: string | undefined,
        predefinedPaymentMethodImagePath: string | undefined,
        customPaymentMethodImagePath: string | undefined,
        provider: PaymentProvider | undefined,
        state: PaymentState | undefined
    ): string {
        // Card
        if (brand != null && ccDigits != null) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${Format.cardIconByBrand(brand)}');"></span> •••• ${ccDigits}${region !== undefined ? " / " + region : ""}</div>`;
        }
        // Actual payment method
        else if (actualPaymentMethodImagePath != null && actualPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${actualPaymentMethodImagePath}');"></span></div>`;
        }
        // Offline payment
        else if (
            provider == null &&
            predefinedPaymentMethodImagePath != null &&
            predefinedPaymentMethodImagePath != ""
        ) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${predefinedPaymentMethodImagePath}');"></span></div>`;
        } else if (customPaymentMethodImagePath != null && customPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${customPaymentMethodImagePath}');"></span></div>`;
        }

        // We want to use a fallback for online payment only when they are confirmed
        if (state == PaymentState.Confirmed) {
            if (customPaymentMethodImagePath != null && customPaymentMethodImagePath != "") {
                return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${customPaymentMethodImagePath}');"></span></div>`;
            }

            if (predefinedPaymentMethodImagePath != null && predefinedPaymentMethodImagePath != "") {
                return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${predefinedPaymentMethodImagePath}');"></span></div>`;
            }
        }

        return '<div class="ccinfo">' + unknownText + "</div>";
    }
}
